module.exports = "<div class=\"content\" fxLayout=\"column\">\n    <ng-content> </ng-content>\n</div>\n\n"